import {
  createStore
} from 'vuex'
import {
  actions
} from '@/globalState'
import state from '@/store/state'
import getters from '@/store/getters'
import mutations from '@/store/mutations'
/**
 * modules
 */
import user from './modules/user'
import share from './modules/share'
import system from './modules/system'
import dict from './modules/dict'
const store = createStore({
  devtools: true,
  state,
  getters,
  mutations,
  modules: {
    share,
    user,
    system,
    dict
  }
})

// 监听 mutation 变化, 将对应信息传递到qiankun的全局变量
store.subscribe((mutation, state) => {
  // 当前传递整个share对象
  if (mutation.type.startsWith('share/')) {
    actions.setGlobalState({
      ...state.share
    })
  }
})

export default store